/**
 * Searches the object and returns the object at the keypath, if a match is found.
 *
 * @param {Object} object The object to search.
 * @param {String} keypath The keypath to search.
 * @returns
 * @memberof owalui
 */
export function objectAtKeypath (object, keypath) {
  let haystack = object
  let keys = keypath.split('.')
  let key = keys.shift()
  while (key) {
    haystack = haystack[key]
    if (!haystack) {
      break
    }
    key = keys.shift()
  }
  return haystack
}
